import $ from 'jquery';
import './vendor/sitevision-jquery-ui';
import 'jquery-migrate';


const $svjq = window.$svjq = window.jQuery = $.noConflict();

export default $svjq;